module.exports = __webpack_public_path__ + "img/cup-straw.19afbda2.svg";